import PropTypes from 'prop-types';
import React from 'react';
import ErrorLabel from '../../Elements/ErrorLabel/ErrorLabel';
import FormElementWithLabel from '../../Input/FormElementWithLabel/FormElementWithLabel';
import Typeahead from '../../Input/Typeahead/Typeahead';
import WithTypeahead from '../../Input/Typeahead/WithTypeahead';

import './InterestTypeahead.scss';

export const CREATE_INTEREST_API = '/api/interest/create';
export const INTEREST_TYPEAHEAD_API = '/api/interest/typeahead';
const SEMICOLON_KEY = 186;
const COMMA_KEY = 188;
const ENTER_KEY = 13;

export class InterestTypeahead extends React.PureComponent {
    static propTypes = {
        /**
         * can new interest be added
         */
        allowAddNewItem: PropTypes.bool,
        /**
         * array of interests
         */
        items: PropTypes.array.isRequired,
        /**
         * string of placeholder
         */
        placeholder: PropTypes.string,
        /**
         * number of max characters count allowed for interest text input
         */
        inputMaxLength: PropTypes.number,
        /**
         * object of Field Label props
         */
        fieldLabelProps: PropTypes.shape({
            /**
             * string label for text area input
             */
            label: PropTypes.string.isRequired,
            /**
             * boolean to show tooltip or not
             */
            shouldShowTooltip: PropTypes.bool,
            /**
             * string of text in tooltip
             */
            tooltipText: PropTypes.string,
        }),
        /**
         * error handling callback
         */
        onErrorUpdate: PropTypes.func,
        /**
         * function to call when item gets added or removed
         */
        onUpdate: PropTypes.func,
        withTags: PropTypes.bool,
        className: PropTypes.string,
    };

    static defaultProps = {
        allowAddNewItem: true,
        error: '',
        fieldLabelProps: {
            label: 'Group Interests',
            shouldShowTooltip: false,
            tooltipText: '',
        },
        inputMaxLength: 60,
        onUpdate: () => {},
        onErrorUpdate: () => {},
        placeholder: 'Detective, Books',
        withTags: true,
        className: '',
    };

    render() {
        return (
            <div
                className={`component-Groups-InterestTypeahead ${this.props.className}`}
            >
                <FormElementWithLabel
                    fieldLabelProps={this.props.fieldLabelProps}
                    inputMaxLength={this.props.inputMaxLength}
                    elementValue={this.props.typeaheadInput}
                    error={this.props.error}
                >
                    <Typeahead
                        allowAddNewItem={
                            this.props.allowAddNewItem && !this.props.error
                        }
                        createNewItemApi={CREATE_INTEREST_API}
                        fetchSuggestionsApi={INTEREST_TYPEAHEAD_API}
                        inputMaxLength={this.props.inputMaxLength}
                        isMulti={true}
                        onChange={this.props.setTypeaheadInput}
                        onError={this.props.handleError}
                        onSelect={this.props.handleSelect}
                        placeholderText={this.props.placeholder}
                        selectedSuggestions={this.props.items}
                        withTags={this.props.withTags}
                        enterKeys={{
                            codes: [ENTER_KEY, SEMICOLON_KEY, COMMA_KEY],
                            values: [',', ';'],
                        }}
                    />
                </FormElementWithLabel>
            </div>
        );
    }
}

export default WithTypeahead(InterestTypeahead);
